import React from "react";

import { UseFormReturn } from "react-hook-form";

import {
    Box,
    Button,
    Typography
} from "@mui/material";

import {
    t,
    Trans
} from "@lingui/macro";

import {
    ZPlayLoader,
    NavigationBack
} from "commons";

import { ManageGenreState } from "./models";
import { DefaultTypedResponse } from "models/response";
import { Genre } from "models";

import { ContentProducerService } from "services/content-producer-service";
import AddIcon from "@mui/icons-material/Add";
import { withSnackbar, WithSnackbarProps } from "notistack";
import { CreateAndEditGenreModal, GenreTable } from "components/backoffice/genre";


class ManageGenre extends React.Component<UseFormReturn & WithSnackbarProps, ManageGenreState>{

    constructor(props: any) {
        super(props);

        this.state = {
            searchFilter: null,
            pagination: { pageSize: 20, pageIndex: 0 },
            genreCount: 0,
            genreList: [],
            data: null,
            isLoading: true,
            openEditGenreModal: false,
            openCreateGenreModal: false,
            editGenre: null
        };
    }


    public componentDidMount() {
        this.getPaginatedGenreWithStateParameters();
    };

    private paginationUpdated = (pagination: any) => {

        ////****
        //VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
        ////****

        this.setState(
            () => ({
                isLoading: true,
                pagination: pagination
            }),
            () => ContentProducerService.getGenreListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getGenreCallback, this.getGenreErrorCallback)
        );

    }

    private getPaginatedGenreWithStateParameters = () => {

        this.setState(() => ({
            isLoading: true,
        }));

        ContentProducerService.getGenreListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getGenreCallback, this.getGenreErrorCallback);
    }

    private deleteGenre = (id: string): void => {

        this.setState(() => ({
            isLoading: true,
        }));

        if ((this.state.genreList.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0) {
            this.setState((prevState) => ({
                pagination: {
                    ...prevState.pagination,
                    pageIndex: this.state.pagination.pageIndex - 1
                }
            }));
        };

        ContentProducerService.deleteGenre(id, this.getPaginatedGenreWithStateParameters, this.deleteGenreErrorCallback);
    }


    private getGenreCallback = (data: DefaultTypedResponse<Genre>): void => {

        this.setState(() => ({
            genreCount: data.size,
            genreList: data.list,
            isLoading: false,
        }));
    };

    private editGenreCallback = (): void => {
        this.setState(() => ({ openEditGenreModal: false }));
        this.getPaginatedGenreWithStateParameters();
    };

    private createGenreCallback = (): void => {
        this.setState(() => ({ openCreateGenreModal: false }));
        this.getPaginatedGenreWithStateParameters();
    };

    private deleteGenreErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mg-error-delete-genre",
            message: "Si è verificato un errore. Il genre non è stato eliminato"
        }), {
            variant: "error",
        });
    }

    private getGenreErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mg-error-get-genre",
            message: "Si è verificato un errore."
        }), {
            variant: "error",
        });
    };

    private editGenreErrorCallback = (err: any): void => {
        this.setState(() => ({
            openEditGenreModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mg-error-edit-genre",
            message: "Si è verificato un errore. Il genre non è stato modificato"
        }), {
            variant: "error",
        });
    };

    private createGenreErrorCallback = (err: any): void => {
        this.setState(() => ({
            openCreateGenreModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mg-error-create-genre",
            message: "Si è verificato un errore. Il genre non è stato creato"
        }), {
            variant: "error",
        });
    };


    private openEditGenreModal = (genre: Genre): void => {
        this.setState(() => ({
            openEditGenreModal: true,
            editGenre: genre
        })
        )
    }

    private closeModal = (): void => {
        this.setState(() => ({
            openEditGenreModal: false,
            editGenre: null,
            openCreateGenreModal: false
        }));
    };

    private openCreateGenreModal = (): void => {
        this.setState(() => ({
            openCreateGenreModal: true,
        })
        )
    }

    render() {
        return (
            <Box sx={{ textAlign: "center", p: 5 }}>
                <NavigationBack />
                <Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                    <Trans id="mg-text-title">Generi</Trans>
                </Typography>
                <Box sx={{ textAlign: "right", pr: 2 }}>
                    <Button
                        endIcon={<AddIcon />}
                        onClick={this.openCreateGenreModal}
                        variant={"contained"}
                    >
                        <Trans id="mg-button-add">Aggiungi</Trans>
                    </Button>
                </Box>
                {<Box sx={{ p: 2, mt: 2 }}>
                    <GenreTable
                        pagination={this.state.pagination}
                        genres={this.state.genreList}
                        totalGenreCount={this.state.genreCount}
                        deleteGenre={this.deleteGenre}
                        openEditGenreTable={this.openEditGenreModal}
                        updatePaginationCallBackFn={this.paginationUpdated}
                    />
                </Box>}
                {this.state.openEditGenreModal && <CreateAndEditGenreModal
                    closeModal={this.closeModal}
                    editGenreCallback={this.editGenreCallback}
                    editGenreErrorCallback={this.editGenreErrorCallback}
                    genre={this.state.editGenre}
                />}
                {this.state.openCreateGenreModal && <CreateAndEditGenreModal
                    closeModal={this.closeModal}
                    createGenreCallback={this.createGenreCallback}
                    createGenreErrorCallback={this.createGenreErrorCallback}
                />}
                {this.state.isLoading && <ZPlayLoader />}
            </Box>);
    }
}

export default withSnackbar(ManageGenre);